import React from "react";
import { motion } from "framer-motion";

const ServiceManage = ({
  label,
  title,
  description,
  steps = [],
  buttonText = "Get a Quote",
  onButtonClick,
  bgImage
}) => {
  return (
    <section className="cta-section"
     style={bgImage ? { "--cta-bg": `url(${bgImage})` } : undefined}>
      <div className="cta-container">

        {/* TOP CONTENT */}
        <div className="cta-top">
          {label && (
            <motion.p
              className="section-label"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              {label}
            </motion.p>
          )}

          {title && (
            <motion.h2
              className="section-title"
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              {title}
            </motion.h2>
          )}

          {description && (
            <motion.p
              className="section-text"
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              viewport={{ once: true }}
            >
              {description}
            </motion.p>
          )}
        </div>

        {/* STEPS */}
        {steps.length > 0 && (
          <motion.div
            className="cta-steps"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.2,
                  delayChildren: 0.3,
                },
              },
            }}
          >
            {steps.map((item, index) => (
              <motion.div
                className="cta-step-card"
                key={index}
                variants={{
                  hidden: { opacity: 0, y: 50, scale: 0.9 },
                  visible: {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    transition: {
                      duration: 0.7,
                      ease: [0.22, 1, 0.36, 1],
                    },
                  },
                }}
                whileHover={{ y: -8, scale: 1.04 }}
                transition={{ type: "spring", stiffness: 220 }}
              >
                <motion.div
                  className="step-number"
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  viewport={{ once: true }}
                >
                  {String(index + 1).padStart(2, "0")}
                </motion.div>

                <div className="step-content">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        )}

        {/* BUTTON */}
        <a href='/enquiry#enquiry-form'>
        {buttonText && (
          <motion.div
            className="cta-btn-wrap"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            viewport={{ once: true }}
          >
            <motion.button
              className="primary-btn"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 300 }}
              onClick={onButtonClick}
            >
              {buttonText}
            </motion.button>
          </motion.div>
        )}
</a>
      </div>
    </section>
  );
};

export default ServiceManage;